import React, { useContext } from "react";

import { commonMessages } from "infrastructure/localization";
import { ErrorContent } from "ui/components";
import { useLocalizedValues } from "ui/hooks";

import { IAuthorizationData } from "./UserProvider.state";

import { UserContext } from ".";

interface IAuthorizedContentProps {
  requiredAuthorizationData?: IAuthorizationData[];
  displayUnauthorizedMessage?: boolean;
}

export const AuthorizedContent: React.FC<IAuthorizedContentProps> = ({ requiredAuthorizationData, displayUnauthorizedMessage, children }) => {
  const localizedValues = useLocalizedValues(() => ({
    errorText: commonMessages.error("accessDenied")
  }));

  const userContext = useContext(UserContext);

  if (userContext.isAuthorized(requiredAuthorizationData)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  } else {
    return displayUnauthorizedMessage ? <ErrorContent text={localizedValues.errorText} /> : null;
  }
};
